import * as React from "react";
import { classNames } from "uitk-react-utils";
import { withStores } from "stores";
import { SeparatorProps, SeparatorModel, SeparatorFTNodeOptions } from "components/flexComponents/Separator/typings";
import { normalizeOptionsData } from "src/stores/FlexTemplateStore";

export const Separator = withStores(
  "flexModuleModelStore",
  "context"
)((props: SeparatorProps) => {
  const { flexTemplateNode, flexModuleModelStore } = props;

  /* istanbul ignore if */
  if (!flexTemplateNode || !flexModuleModelStore) {
    return null;
  }

  const { id } = flexTemplateNode;
  const model = flexModuleModelStore.getModel(id) as SeparatorModel | null;
  const { spacing, flexComponentView } = normalizeOptionsData(flexTemplateNode, model) as SeparatorFTNodeOptions;

  const separatorClasses = classNames({
    "all-y-margin-six": spacing === "six",
    "all-y-margin-four": spacing === "four",
    "all-y-margin-three": spacing === "three",
    "all-y-margin-two": spacing === "two",
  });

  if (flexComponentView === "simple") {
    const simpleSeparatorClasses = classNames("uitk-cell", {
      "all-t-padding-twelve": spacing === "twelve",
      "all-t-padding-six": spacing === "six",
      "all-t-padding-four": spacing === "four",
      "all-t-padding-three": spacing === "three",
      "all-t-padding-two": spacing === "two",
      "all-t-padding-one": spacing === "one",
      "all-t-padding-half": spacing === "half",
    });

    return <div className={simpleSeparatorClasses} data-testid="simple-separator" />;
  }

  return (
    <div className="SeparatorModule" data-testid="default-separator">
      <hr className={separatorClasses} />
    </div>
  );
});

Separator.displayName = "Separator";

export default Separator;
